import React from "react";
import Header from "../components/Header"; // include your header
import { Link } from "react-router-dom";
import Footer from "./Footer";

export default function TermsAndConditions() {
  return (
    <>
      <Header hideBookButton={false} />
      <div className="pt-20 min-h-screen bg-[#204080] text-blue-100 px-6 py-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-white mb-6 border-b border-white/30 pb-2 text-center">
  Terms and Conditions
</h1>


          <p className="mb-6 text-blue-200">
            These Terms and Conditions ("Terms") govern your use of the Visakha Physiotherapy & Jasti
            Chiropractic (VPJC) website. By accessing or using this site, you agree to comply with these
            Terms.
          </p>

          <section className="mb-6">
            <h2 className="text-2xl font-semibold text-white mb-2">1. Purpose</h2>
            <p className="text-blue-200">
              The VPJC website allows users to learn about our physiotherapy and chiropractic services,
              book appointments (in-clinic, home visit, or virtual), apply for jobs, and subscribe to our
              newsletter.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-2xl font-semibold text-white mb-2">2. Use of the Website</h2>
            <ul className="list-disc pl-6 space-y-1 text-blue-200">
              <li>You agree to provide accurate and complete information when using our services.</li>
              <li>You are responsible for maintaining the confidentiality of your login credentials.</li>
              <li>You must not misuse the website or attempt to disrupt its functionality.</li>
            </ul>
          </section>

          <section className="mb-6">
            <h2 className="text-2xl font-semibold text-white mb-2">3. No Medical Advice</h2>
            <p className="text-blue-200">
              All information provided on this website is for general informational purposes only and does
              not constitute medical advice. For specific health concerns, please consult a qualified
              healthcare professional.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-2xl font-semibold text-white mb-2">4. Limitation of Liability</h2>
            <p className="text-blue-200">
              VPJC is not responsible for any damages or losses resulting from the use or inability to use
              this website or from any inaccuracies in user-submitted data.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-2xl font-semibold text-white mb-2">5. Data Protection</h2>
            <p className="text-blue-200">
              Your personal data is handled in accordance with our{" "}
              <Link to="/privacy-policy" className="text-white underline">
                Privacy Policy
              </Link>.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-2xl font-semibold text-white mb-2">6. Governing Law</h2>
            <p className="text-blue-200">These Terms are governed by the laws of India.</p>
          </section>

          <section className="mb-6">
            <h2 className="text-2xl font-semibold text-white mb-2">7. Intellectual Property</h2>
            <p className="text-blue-200">
              All logos, designs, and content are owned by VPJC and cannot be reproduced without permission.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-2xl font-semibold text-white mb-2">8. Termination</h2>
            <p className="text-blue-200">
              We reserve the right to suspend or terminate user accounts if any misuse is detected.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-2">9. Modifications</h2>
            <p className="text-blue-200">
              We reserve the right to modify these Terms at any time. Continued use of the website implies
              acceptance of the updated Terms.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-2xl font-semibold text-white mb-2">10. Contact Information</h2>
            <p className="text-blue-200">
              For any questions about these Terms, please email{" "}
              <a href="mailto:contact@jastiphysiochiro.com" className="text-white underline">
                contact@jastiphysiochiro.com
              </a>.
            </p>
          </section>

          <p className="mt-8 text-blue-200">
            <strong>Last Updated:</strong> October 2025
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
}